<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">审批</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>法币出金</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content">
      <div class="page-actions">
        <!-- <el-select v-model="coinType" placeholder="请选择coinType" clearable>
          <el-option v-for="item in coinList" :key="item" :label="item" :value="item"></el-option>
        </el-select> -->
        <el-select v-model="status" placeholder="请选择状态" clearable>
          <el-option
            v-for="item in txStatusOption"
            :key="item.key"
            :label="item.label"
            :value="item.key"
          ></el-option>
        </el-select>
        <!-- <el-select v-model="txDepositStatus" placeholder="请选择txDepositStatus">
          <el-option v-for="item in coinList" :key="item" :label="item" :value="item"></el-option>
        </el-select> -->
        <el-select v-model="tenantId" placeholder="租户选择" clearable>
          <el-option
            v-for="item in tenantList"
            :key="item.id"
            :label="item.tenantName"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-input placeholder="请输入用户Id" v-model="userId" clearable>
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-input placeholder="合伙人UID" v-model="channelUserId" clearable>
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <!-- <el-input placeholder="请输入转入钱包地址" v-model="orderSide" clearable>
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input> -->

        <el-date-picker
          v-model="value1"
          type="daterange"
          align="right"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          unlink-panels
          :clearable="false"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="changeTime($event)"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
        <el-select
          v-model="onlyChannel"
          placeholder="合伙人筛选"
          clearable
          @clear="selectClear"
          @change="selectChange"
        >
          <el-option
            v-for="item in partnerArr"
            :key="item.val"
            :label="item.label"
            :value="item.val"
          ></el-option>
        </el-select>
        <el-input
          placeholder=""
          v-model="inputUid"
          v-if="onlyChannel == -100"
          clearable
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
        <!-- <span>待查询的Hash值为：{{hash}}</span> -->
      </div>
      <div class="pl_total_box">
        <div class="pl_total">
          <span>卖出总计</span>
          <span></span>
          <span>{{ totalInfo | fixD(6) }}</span>
          <!-- <span>USDT</span> -->
        </div>
        <!-- <div class="pl_total">
          <span>总计盈亏</span>
          <span></span>
          <span>{{ totalRealizedProfit | fixD(6) }}</span>
          <span>USDT</span>
        </div> -->
        <!-- <div class="pl_total">
          <span>持仓手续费汇总</span>
          <span></span>
          <span>{{ totalFee | fixD(6) }}</span>
          <span>USDT</span>
        </div> -->
      </div>
      <audit-list @refresh="refreshList($event)"></audit-list>
    </el-card>
  </div>
</template>

<script>
import "./store";
import { mapState, mapActions, mapMutations } from "vuex";
import AuditList from "./components/list";
import { tenantInfo } from "@/common/publicApi";
export default {
  name: "loglim",
  data() {
    return {
      partnerArr: [
        { label: "仅查询合伙人", val: -1 },
        { label: "合伙人UID", val: -100 },
      ],
      onlyChannel: "",
      inputUid: "",
      coinType: "",
      userId: "",
      channelUserId: "",
      status: 1,
      orderSide: "",
      value1: [],
      // value1: [
      // moment(new Date().getTime() - 7 * 1000 * 24 * 60 * 60).format(
      //     "YYYY-MM-DD"
      //   ),
      //   new Date().getFullYear() +
      //     '-' +
      //     (new Date().getMonth() + 1) +
      //     '-' +
      //     new Date().getDate(),
      // ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      txStatusOption: [
        { label: "全部", key: "" },
        { label: "审核中", key: -2 },
        { label: "进行中", key: -1 },
        { label: "成功", key: 1 },
        { label: "失败", key: 0 },
      ],
      tenantId: "",
      tenantList: [],
    };
  },
  components: {
    AuditList,
  },
  computed: {
    ...mapState("otcWithdraw", ["pagination", "coinList", "totalInfo"]),
    ...mapState("mining", ["coinTypeList"]),
    startDate() {
      let time = new Date(
        new Date(this.value1[0]).setHours(0, 0, 0, 0)
      ).getTime();
      return this.value1 && this.value1.length > 0 ? time : "";
    },
    endDate() {
      const time = new Date(
        new Date(this.value1[1]).setHours(23, 59, 59, 999)
      ).getTime();
      return this.value1 && this.value1.length > 0 ? time : "";
    },
  },
  methods: {
    ...mapActions("otcWithdraw", [
      "gethashList",
      "getAllCoins",
      "getTotalInfo",
    ]),
    ...mapActions("mining", ["getCoinTypeList"]),
    ...mapMutations("otcWithdraw", ["setpage"]),
    changeTime(e) {
      this.gethashList({
        userId: this.userId,
        channelUserId: this.channelUserId,
        status: this.status,
        orderSide: 2,
        startTime: this.startDate,
        endTime: this.endDate,
        ...this.pagination,
        onlyChannel: this.onlyChannel == -1 ? this.onlyChannel : this.inputUid,
        tenantId: this.tenantId,
      });
      this.getTotalInfo({
        userId: this.userId,
        channelUserId: this.channelUserId,
        status: this.status,
        orderSide: 2,
        startTime: this.startDate,
        endTime: this.endDate,
        onlyChannel: this.onlyChannel == -1 ? this.onlyChannel : this.inputUid,
        tenantId: this.tenantId,
      });
    },
    refreshList(data = {}) {
      this.gethashList({
        userId: this.userId,
        channelUserId: this.channelUserId,
        status: this.status,
        orderSide: 2,
        startTime: this.startDate,
        endTime: this.endDate,
        //  ...this.pagination,
        ...data,
        onlyChannel: this.onlyChannel == -1 ? this.onlyChannel : this.inputUid,
        tenantId: this.tenantId,
      });
      this.getTotalInfo({
        userId: this.userId,
        channelUserId: this.channelUserId,
        status: this.status,
        orderSide: 2,
        startTime: this.startDate,
        endTime: this.endDate,
        onlyChannel: this.onlyChannel == -1 ? this.onlyChannel : this.inputUid,
        tenantId: this.tenantId,
      });
    },
    handleSearch() {
      this.setpage = { ...this.pagination, page: 1 };
      this.gethashList({
        userId: this.userId,
        channelUserId: this.channelUserId,
        status: this.status,
        orderSide: 2,
        ...this.pagination,
        startTime: this.startDate,
        endTime: this.endDate,
        page: 1,
        onlyChannel: this.onlyChannel == -1 ? this.onlyChannel : this.inputUid,
        tenantId: this.tenantId,
      });
      this.getTotalInfo({
        userId: this.userId,
        channelUserId: this.channelUserId,
        status: this.status,
        orderSide: 2,
        startTime: this.startDate,
        endTime: this.endDate,
        onlyChannel: this.onlyChannel == -1 ? this.onlyChannel : this.inputUid,
        tenantId: this.tenantId,
      });
    },
    selectClear() {
      this.inputUid = "";
    },
    selectChange() {
      this.inputUid = "";
    },
  },
  mounted() {
    tenantInfo().then((res) => {
      if (res.code == 0) {
        this.tenantList = res.data;
      }
    });
    const query = this.$route.query;
    for (const key in query) {
      this[key] = query[key];
    }

    this.gethashList({
      userId: this.userId,
      channelUserId: this.channelUserId,
      status: this.status,
      orderSide: 2,
      startTime: this.startDate,
      endTime: this.endDate,
      ...this.pagination,
      page: 1,
      onlyChannel: this.onlyChannel == -1 ? this.onlyChannel : this.inputUid,
      tenantId: this.tenantId,
    });
    this.getTotalInfo({
      userId: this.userId,
      channelUserId: this.channelUserId,
      status: this.status,
      orderSide: 2,
      startTime: this.startDate,
      endTime: this.endDate,
      onlyChannel: this.onlyChannel == -1 ? this.onlyChannel : this.inputUid,
      tenantId: this.tenantId,
    });
    // this.getCoinTypeList();
    // this.getAllCoins();
  },
};
</script>

<style lang="less" src="../../../styles/button.less" scoped></style>

<style lang="less" scoped>
.page-actions > .el-input {
  width: 200px;
  min-width: unset;
}
</style>
